import React from 'react';
import useReactApexChart from '../../hook/useReactApexChart';
import ReactApexChart from 'react-apexcharts';
import { Icon } from '@iconify/react/dist/iconify.js';

const LeadsOverview = ({ states }) => {
    const secondChart = states?.second_chart_data || {};
    const series = Object.values(secondChart).map(item => item?.counts || 0);
    const labels = Object.keys(secondChart);

    const colorMap = {
        Pending: "bg-warning-main",
        pending: "bg-warning-main",
        Accepted: "bg-success-main",
        accepted: "bg-success-main",
        Scheduled: "bg-primary-600",
        scheduled: "bg-primary-600",
        Completed: "bg-info-main",
        completed: "bg-info-main",
    };

    const colorCodeMap = {
        Pending: "#FF9F29",
        pending: "#FF9F29",
        Accepted: "#45B369",
        accepted: "#45B369",
        Scheduled: "#39B6E2",
        scheduled: "#39B6E2",
        Completed: "#487FFF",
        completed: "#487FFF",
    };

    const options = {
        colors: labels.map(label => colorCodeMap[label] || "#B0B0B0"),
        labels: labels,
        legend: {
            show: false,
        },
        chart: {
            type: "donut",
            height: 300,
            sparkline: {
                enabled: true,
            },
            margin: { top: -100, right: -100, bottom: -100, left: -100 },
            padding: { top: -100, right: -100, bottom: -100, left: -100 },
        },
        stroke: { width: 0 },
        dataLabels: { enabled: false },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: { width: 200 },
                    legend: { position: "bottom" },
                },
            },
        ],
        plotOptions: {
            pie: {
                startAngle: -90,
                endAngle: 90,
                offsetY: 10,
                customScale: 0.8,
                donut: {
                    size: "70%",
                    labels: {
                        show: true,
                        total: {
                            showAlways: true,
                            show: true,
                            label: "Leads Overview",
                        },
                    },
                },
            },
        },
    };

    return (
        <div className="col-xxl-6" style={{ height: "100%" }}>
            <div className="col-xxl-12 col-sm-6 h-100">
                <div className="card h-100 radius-8 border-0 overflow-hidden">
                    <div className="card-body p-16 h-100">
                        <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                            <h6 className="mb-2 fw-bold text-lg">Leads Overview</h6>
                        </div>
                        <div className="d-flex flex-wrap align-items-center mt-3">
                            <ul className="flex-shrink-0">
                                {Object.entries(states?.second_chart_data || {}).map(([label, data]) => (
                                    <li key={label} className="d-flex align-items-center gap-2 mb-2">
                                        <span className={`w-12-px h-12-px rounded-circle ${colorMap[label] || "bg-secondary-light"}`} />
                                        <span className="text-secondary-light text-sm fw-medium">
                                            {label}: {data?.counts ?? 0}
                                        </span>
                                    </li>
                                ))}
                            </ul>

                            <div>
                                <ReactApexChart
                                    options={options}
                                    series={series}
                                    type="donut"
                                    height={250}
                                    id="donutChart"
                                    className="flex-grow-1 apexcharts-tooltip-z-none title-style circle-none"
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeadsOverview;